import { jsx as t } from "react/jsx-runtime";
import { FlexBlock as x } from "../../primitives/flex-block/flex-block.js";
import l from "clsx";
import { forwardRef as m } from "react";
import '../../assets/box.css';const n = "_box_qo0qh_1", r = {
  box: n,
  "box--border": "_box--border_qo0qh_10",
  "box--raised": "_box--raised_qo0qh_14"
}, _ = m(
  ({
    className: o = "",
    border: s = !1,
    children: d,
    raised: i,
    relative: b = !0,
    ...c
  }, a) => /* @__PURE__ */ t(
    x,
    {
      relative: b,
      bg: "primary",
      direction: "column",
      "data-role": "box",
      width: "full-width",
      className: l(
        {
          [r.box]: !0,
          [r["box--border"]]: !!s,
          [r["box--raised"]]: !!i
        },
        o
      ),
      ref: a,
      ...c,
      children: d
    }
  )
), e = (o) => /* @__PURE__ */ t(x, { direction: "column", ...o }), q = e, u = e, y = e;
_.displayName = "Box";
export {
  _ as Box,
  u as BoxBody,
  y as BoxFooter,
  q as BoxHeader
};
